module.exports = __webpack_public_path__ + "img/mb-inner.3f7f3f3e.png";